/* src/app/shared/controls/auto-complete-dropdown/auto-complete-dropdown.component.scss */
.input-group {
  position: relative;
  margin-bottom: 0;
  overflow: visible;
}
.input-group.period-type {
  max-width: 100px;
  min-width: 100px;
  width: 100px;
  flex: 0 0 100px;
}
.input-group.status-type {
  max-width: 120px;
  min-width: 120px;
  width: 120px;
  flex: 0 0 120px;
}
.input-group.input-type {
  max-width: 400px;
  min-width: 400px;
  width: 400px;
  flex: 0 0 400px;
}
.input-wrapper {
  position: relative;
  width: 100%;
}
.readonly-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  height: 38px;
  padding: 0 10px;
  border: 1px solid #006f8a;
  border-radius: 4px;
  background-color: white;
  color: #333;
  cursor: pointer;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.4;
}
.period-type .readonly-trigger,
.status-type .readonly-trigger {
  border: 1px solid #ebebeb;
  border-radius: 10px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}
.readonly-trigger.disabled {
  background-color: #f5f5f5;
  color: #bbb;
  cursor: not-allowed;
  pointer-events: none;
}
.autocomplete-dropdown.disabled {
  background-color: #f5f5f5;
  color: #bbb;
  pointer-events: none;
}
.autocomplete-dropdown li.disabled {
  color: #bbb;
  pointer-events: none;
}
.autocomplete-dropdown .filter-input input:disabled {
  background-color: #f5f5f5;
  color: #bbb;
  cursor: not-allowed;
}
.trigger-text {
  position: absolute;
  top: 50%;
  left: 10px;
  right: 34px;
  transform: translateY(-46%);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #333;
}
.icon-button {
  position: absolute;
  right: 34px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  font-size: 16px;
  color: #006f8a;
  padding: 2px;
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.icon-button:hover {
  color: #333;
}
.dropdown-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #006f8a;
  pointer-events: none;
  font-size: 14px;
  transition: transform 0.3s ease;
}
.dropdown-icon.open {
  transform: translateY(-50%) rotate(180deg);
}
.autocomplete-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 4px;
  padding: 0;
  background-color: #f9f9f9;
  font-size: 14px;
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  z-index: 1000;
  box-sizing: border-box;
  border: 1px solid #bbb;
  border-radius: 4px;
  transition: max-height 0.2s ease, opacity 0.2s ease;
  scrollbar-width: thin;
  scrollbar-color: #bbb transparent;
  pointer-events: none;
}
.autocomplete-dropdown.open {
  max-height: 175px;
  opacity: 1;
  overflow-y: auto;
  pointer-events: auto;
}
.autocomplete-dropdown .filter-input {
  height: 32px;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  background-color: #ffffff;
}
.status-type .filter-input,
.status-type .separator {
  display: none;
}
.autocomplete-dropdown .filter-input input {
  width: 100%;
  height: 100%;
  padding: 6px 10px;
  border: none;
  background-color: transparent;
  font-size: 14px;
  line-height: 1.5;
  outline: none;
  color: #333;
  font-family: inherit;
  display: block;
  box-sizing: border-box;
}
.autocomplete-dropdown .filter-input input::placeholder {
  color: #999;
  font-style: italic;
  line-height: 1.5;
}
.separator {
  height: 0;
  border: none;
  border-top: 1px solid #bbb;
  margin: 0;
}
.autocomplete-dropdown li {
  padding: 4px 10px;
  margin: 0;
  list-style: none;
  cursor: pointer;
  border-bottom: 1px solid #eee;
  transition: background-color 0.15s ease;
}
.autocomplete-dropdown li:nth-child(n+2):nth-child(odd) {
  background-color: #f8f8f8;
}
.autocomplete-dropdown li:nth-child(n+2):nth-child(even) {
  background-color: #ffffff;
}
.autocomplete-dropdown li:last-child {
  border-bottom: none;
}
.autocomplete-dropdown.open li:hover {
  background-color: #e0e0e0;
}
/*# sourceMappingURL=auto-complete-dropdown.component-5IGX2BOR.css.map */
